import { getAppNotifications } from 'redux/actions/app.actions'

export const createNotificationsChannel = (consumer, emit, END) => {
  const subscription = consumer.subscriptions.create('NotificationsChannel', {
    initialized() {
      this.read = this.read.bind(this)
      this.delete = this.delete.bind(this)
      this.uninstall = this.uninstall.bind(this)
    },
    connected() {
      // Called when the subscription is ready for use on the server
      this.install()
    },
    received(data) {
      // Called when there's incoming data on the websocket for this channel
      emit(getAppNotifications(data))
    },
    read(event) {
      const uuids = event.detail?.uuids || []
      uuids.forEach(uuid => {
        this.perform('read', { uuid: uuid })
      })
    },
    delete(event) {
      const uuid = event.detail?.uuid
      if (uuid) {
        this.perform('delete', { uuid: uuid })
      }
    },
    rejected() {
      this.uninstall()
    },
    disconnected() {
      // Called when the subscription has been terminated by the server
      this.uninstall()
      emit(END)
    },
    install() {
      if (document) {
        document.addEventListener('notification:read', this.read)
        document.addEventListener('notification:delete', this.delete)
      }
    },
    uninstall() {
      if (document) {
        document.removeEventListener('notification:read', this.read)
        document.removeEventListener('notification:delete', this.delete)
      }
    }
  })
  return subscription
}

export const closeNotificationChannel = consumer => {
  consumer.subscriptions.subscriptions.forEach(subscription => {
    consumer.subscriptions.remove(subscription)
  })
  consumer.subscriptions.consumer.disconnect()
}
